"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod/v4";
import { InviteUsers } from "@/components/shared/workspace-access/invite-users";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { CardTitle } from "@/components/ui/card";
import { Form } from "@/components/ui/form";
import { IconCard } from "@/components/ui/icon-card";
import { FormInput } from "@/components/ui/input";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import { Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { useSystemViews } from "@/hooks/useSystemViews";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { emitter, type WorkspaceEvents } from "@/lib/emitter";
import { createWorkspaceSchema } from "@/lib/schema/workspace";
import { logger } from "@/lib/services/logger";
import { cn } from "@/lib/utils";
import { getViewIcon } from "@/lib/utils/icons";
import type { InvitedUser } from "@/types/user";
const workspaceNameSchema = z.object({
  name: z.string().trim().min(1, {
    error: "Workspace Name is required"
  })
});
type WorkspaceNameSchema = z.infer<typeof workspaceNameSchema>;
const DEFAULT_SELECTED_WORKSPACE_VIEWS = new Set(["financial statements", "leasing", "work orders", "prospects"]);
export function controlNewWorkspaceModal(properties: WorkspaceEvents["workspace.create.new"]) {
  emitter.emit("workspace.create.new", properties);
}
export function NewWorkspaceModal() {
  const $ = _c(69);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [selectedViews, setSelectedViews] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [invitedUsers, setInvitedUsers] = useState(t1);
  const {
    updateCurrentWorkspace
  } = useCurrentWorkspace();
  const {
    createNewWorkspace,
    creatingWorkspace
  } = useWorkspaces();
  const {
    views: systemViews,
    loading: viewsLoading,
    error: viewsError
  } = useSystemViews();
  let t2;
  if ($[2] !== systemViews) {
    t2 = [...systemViews.filter(_temp)].sort(_temp2);
    $[2] = systemViews;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const allowedSystemViews = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      defaultValues: {
        name: ""
      },
      resolver: zodResolver(workspaceNameSchema)
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const form = useForm(t3);
  let t4;
  let t5;
  if ($[5] !== allowedSystemViews || $[6] !== isOpen) {
    t4 = () => {
      if (!isOpen || !allowedSystemViews?.length) {
        return;
      }
      const resolvedSystemViews = allowedSystemViews.reduce(_temp3, {});
      setSelectedViews(resolvedSystemViews);
    };
    t5 = [allowedSystemViews, isOpen];
    $[5] = allowedSystemViews;
    $[6] = isOpen;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[9] !== isOpen || $[10] !== viewsError) {
    t6 = () => {
      if (viewsError && isOpen) {
        logger.error("Failed to fetch views:", viewsError);
        toast.error("Failed to load available views");
      }
    };
    t7 = [viewsError, isOpen];
    $[9] = isOpen;
    $[10] = viewsError;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      emitter.on("workspace.create.new", t10 => {
        const {
          state
        } = t10;
        setIsOpen(state === "on");
      });
      return _temp4;
    };
    t9 = [];
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  useEffect(t8, t9);
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = viewId => {
      setSelectedViews(prev => ({
        ...prev,
        [viewId]: !prev[viewId]
      }));
    };
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const handleViewToggle = t10;
  let t11;
  if ($[16] !== allowedSystemViews || $[17] !== createNewWorkspace || $[18] !== invitedUsers || $[19] !== selectedViews || $[20] !== updateCurrentWorkspace) {
    t11 = async values => {
      const expiresAt = new Date();
      expiresAt.setHours(expiresAt.getHours() + 72);
      const payload = {
        name: values.name,
        teamMembers: invitedUsers.map(user => ({
          email: user.email,
          expiresAt: expiresAt.toISOString(),
          permissions: user.permissions,
          role: user.role
        })),
        views: allowedSystemViews?.filter(view_1 => selectedViews[view_1.id])
      };
      const validated = createWorkspaceSchema.safeParse(payload);
      if (!validated.success) {
        return toast.error(`Failed to create workspace: \n${validated.error.flatten().formErrors.join(";\n")}`);
      }
      ;
      try {
        const response = await createNewWorkspace(validated.data);
        updateCurrentWorkspace(response.workspace.id);
        controlNewWorkspaceModal({
          state: "off"
        });
        toast.success("Workspace created successfully");
      } catch (t12) {
        toast.error("Failed to create workspace");
      }
    };
    $[16] = allowedSystemViews;
    $[17] = createNewWorkspace;
    $[18] = invitedUsers;
    $[19] = selectedViews;
    $[20] = updateCurrentWorkspace;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const handleSubmit = t11;
  let t12;
  if ($[22] !== selectedViews) {
    t12 = Object.values(selectedViews).filter(Boolean);
    $[22] = selectedViews;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const selectedViewsCount = t12.length;
  let t13;
  if ($[24] !== form) {
    t13 = open => {
      form.reset({
        name: ""
      });
      if (!open) {
        controlNewWorkspaceModal({
          state: "off"
        });
      }
    };
    $[24] = form;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SheetHeader><SheetTitle>Create New Workspace</SheetTitle><SheetDescription className="sr-only">Create a new workspace, select dashboards and invite team members.</SheetDescription></SheetHeader>;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== form || $[28] !== handleSubmit) {
    t15 = form.handleSubmit(handleSubmit);
    $[27] = form;
    $[28] = handleSubmit;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== form) {
    t16 = <FormInput form={form} label="Workspace Name" name="name" placeholder="Enter workspace name" />;
    $[30] = form;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t15 || $[33] !== t16) {
    t17 = <form id="new-workspace-form" onSubmit={t15}>{t16}</form>;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== form || $[36] !== t17) {
    t18 = <Form {...form}>{t17}</Form>;
    $[35] = form;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== allowedSystemViews || $[39] !== selectedViews || $[40] !== selectedViewsCount || $[41] !== viewsLoading) {
    t19 = viewsLoading ? <LoadingSpinner className="py-6" /> : <div className="space-y-5 relative"><div className="flex items-center rounded-lg absolute -top-3 left-0 right-0 pointer-events-none"><CardTitle className="text-sm font-medium bg-white pr-1.5">Dashboards</CardTitle><Separator className="flex-1" />{!!allowedSystemViews?.length && <Badge className="text-xs shrink-0" variant="secondary">{selectedViewsCount} of {allowedSystemViews.length}{" "}selected</Badge>}</div><div className="grid gap-4 grid-cols-1 sm:grid-cols-2 pt-6">{allowedSystemViews.map(view_2 => {
          const isSelected = selectedViews[view_2.id];
          const icon = getViewIcon(view_2.name);
          return <IconCard className={cn("transition-[colors,transform,box-shadow] duration-200 rounded-lg data-[slot=card]:py-1 h-auto [&_h4]:leading-tight border", isSelected ? "shadow-sm border-primary/40" : "border-border shadow-none")} description={view_2.description || ""} icon={icon} isSelected={isSelected} key={view_2.id} onClick={() => handleViewToggle(view_2.id)} title={view_2.name} />;
        })}</div></div>;
    $[38] = allowedSystemViews;
    $[39] = selectedViews;
    $[40] = selectedViewsCount;
    $[41] = viewsLoading;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  let t21;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <CardTitle className="text-sm font-medium bg-white pr-1.5">Team Members</CardTitle>;
    t21 = <Separator className="flex-1" />;
    $[43] = t20;
    $[44] = t21;
  } else {
    t20 = $[43];
    t21 = $[44];
  }
  let t22;
  if ($[45] !== invitedUsers.length) {
    t22 = <div className="flex items-center rounded-lg absolute -top-3 left-0 right-0 pointer-events-none">{t20}{t21}<Badge className="text-xs shrink-0" variant="secondary">{invitedUsers.length} invited</Badge></div>;
    $[45] = invitedUsers.length;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <InviteUsers className="pt-6 pb-5.5" onUsersChange={setInvitedUsers} />;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t22) {
    t24 = <div className="space-y-5 relative">{t22}{t23}</div>;
    $[48] = t22;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t18 || $[51] !== t19 || $[52] !== t24) {
    t25 = <div className="flex-1 overflow-hidden"><ScrollArea className="h-full"><div className="gap-y-10 px-4 flex flex-col">{t18}{t19}{t24}</div></ScrollArea></div>;
    $[50] = t18;
    $[51] = t19;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  const t26 = creatingWorkspace ? "Creating..." : "Create Workspace";
  let t27;
  if ($[54] !== creatingWorkspace || $[55] !== t26) {
    t27 = <Button disabled={creatingWorkspace} form="new-workspace-form">{t26}</Button>;
    $[54] = creatingWorkspace;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== creatingWorkspace) {
    t28 = <SheetClose asChild={true}><Button disabled={creatingWorkspace} variant="outline">Cancel</Button></SheetClose>;
    $[57] = creatingWorkspace;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t27 || $[60] !== t28) {
    t29 = <SheetFooter>{t27}{t28}</SheetFooter>;
    $[59] = t27;
    $[60] = t28;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t25 || $[63] !== t29) {
    t30 = <SheetContent className="w-full max-w-[95dvw] sm:max-w-screen-sm bg-white" side="right"><div className="flex h-full flex-col">{t14}{t25}{t29}</div></SheetContent>;
    $[62] = t25;
    $[63] = t29;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  if ($[65] !== isOpen || $[66] !== t13 || $[67] !== t30) {
    t31 = <Sheet onOpenChange={t13} open={isOpen}>{t30}</Sheet>;
    $[65] = isOpen;
    $[66] = t13;
    $[67] = t30;
    $[68] = t31;
  } else {
    t31 = $[68];
  }
  return t31;
}
function _temp4() {
  emitter.off("workspace.create.new");
}
function _temp3(accumulator, view_0) {
  accumulator[view_0.id] = DEFAULT_SELECTED_WORKSPACE_VIEWS.has(view_0.name.toLowerCase());
  return accumulator;
}
function _temp2(firstView, secondView) {
  return firstView.name.localeCompare(secondView.name);
}
function _temp(view) {
  return !["reputation", "investors"].includes(view.name.toLowerCase());
}